import _ from 'lodash';
import { tabShape } from './utils';

const parent = '> .drzTabs > .drzTabs-content > .drzTabs-tabContent >';
const lastRowSelector = `${parent} .row:last-child, ${parent} .row:last-of-type, ${parent} .row:only-child, ${parent} .row:only-of-type`;

export default function tabs() {
  return {
    _id: false,
    type: 'puddle.tabs',
    layout: 'top',
    mediaQueries: [
      {
        selector: '.drzTabs-tab',
        properties: [
          {
            property: 'border-color',
            desktop: 'default',
            tablet: 'default',
            mobile: 'default',
          },
        ],
      },
      {
        selector: lastRowSelector,
        properties: [
          {
            property: 'margin-bottom',
            desktop: '0px',
            tablet: 'default',
            mobile: 'default',
          },
        ],
      },
      {
        selector: '.drzTabs-tabLink',
        properties: [
          {
            property: 'color',
            desktop: 'default',
            tablet: 'default',
            mobile: 'default',
          },
        ],
      },
      {
        selector: '.drzTabs-activeTab .drzTabs-tabLink',
        properties: [
          {
            property: 'color',
            desktop: 'default',
            tablet: 'default',
            mobile: 'default',
          },
        ],
      },
      {
        selector: '.drzTabs-activeTab',
        properties: [
          {
            defaultColor: true,
            property: 'border-color',
            desktop: 'default',
            tablet: 'default',
            mobile: 'default',
          },
          {
            property: 'background-color',
            desktop: 'default',
            tablet: 'default',
            mobile: 'default',
          },
        ],
      },
      {
        selector: '.drzTabs-tab-top.drzTabs-activeTab:before',
        properties: [
          {
            property: 'border-color',
            desktop: 'default',
            tablet: 'default',
            mobile: 'default',
          },
        ],
      },
      {
        selector: '.drzTabs-tab-top.drzTabs-activeTab:after',
        properties: [
          {
            property: 'border-color',
            desktop: 'default',
            tablet: 'default',
            mobile: 'default',
          },
        ],
      },
      {
        selector: '.drzTabs-tab-left.drzTabs-activeTab:before',
        properties: [
          {
            property: 'border-color',
            desktop: 'default',
            tablet: 'default',
            mobile: 'default',
          },
        ],
      },
      {
        selector: '.drzTabs-tab-left.drzTabs-activeTab:after',
        properties: [
          {
            property: 'border-color',
            desktop: 'default',
            tablet: 'default',
            mobile: 'default',
          },
        ],
      },
      {
        selector: '.drzTabs-content',
        properties: [
          {
            property: 'border-color',
            desktop: 'default',
            tablet: 'default',
            mobile: 'default',
          },
        ],
      },
      {
        global: true,
        selector: '.drzTabs',
        properties: [],
      },
    ],
    tabs: _.times(2, tabShape()),
    lastRowSelector,
    menuClassList: [],
    tabClassList: ['drzTabs-tab-top'],
    contentClassList: [],
    pageCSS: '',
    bounceDroplet: false,
    isShared: false,
    templateRegion: false,
  };
}



// WEBPACK FOOTER //
// ./src/global-view/editor/droplets/tabs/droplet.schema.js